import React, { useRef } from 'react';
import cn from 'clsx';
import {
  Button,
  CardMedia,
  CardLinkWithGAPromoClick,
  MediaCard,
  MediaCardContent,
  MediaCardDescription,
  MediaCardTitle,
  SectionTitle,
} from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey } from 'utils';
import { SYSTEMS_SECTION_CARD_LIST } from './systems-section-constants';
import {
  cardDescription,
  cardTitle,
  systems,
  systemsCardContent,
  systemsImage,
  systemsImageWrapper,
  systemsSection,
  systemsTitle,
  cardButton,
  cardCommonStyle,
} from './systems-section-styles';
import { SystemsSectionCardStructure } from './systems-section-types';

/**
 * Вью секции со списком решений
 */
export const SystemsSection = () => {
  const refs = useRef<HTMLAnchorElement[]>([]);

  const promotions = SYSTEMS_SECTION_CARD_LIST.map(({ card }, index: number) => ({
    name: 'SistemyInzhenernye_top',
    creative: card.content.title,
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(refs, 'landingSistemyInzhenernye / solutions', promotions);

  return (
    <section className={systemsSection}>
      <SectionTitle className={systemsTitle}>Какие решения мы&nbsp;предлагаем</SectionTitle>
      <div className={systems}>
        {SYSTEMS_SECTION_CARD_LIST.map(
          ({ link, card, cardStyle }: SystemsSectionCardStructure, index: number) => (
            <CardLinkWithGAPromoClick
              bannerRefs={refs}
              className={cn(cardStyle, cardCommonStyle)}
              elementBlock="landingSistemyInzhenernye / solutions"
              position={index}
              promotion={promotions[index]}
              key={createElementKey('system', index)}
              {...link}>
              <MediaCard>
                <div className={systemsImageWrapper}>
                  <CardMedia className={systemsImage} {...card.media} />
                </div>
                <MediaCardContent className={systemsCardContent}>
                  <div>
                    <MediaCardTitle as="h3" className={cardTitle} variant="h2">
                      {card.content.title}
                    </MediaCardTitle>
                    <MediaCardDescription className={cardDescription} size="body_long">
                      {card.content.description}
                    </MediaCardDescription>
                  </div>
                  <Button className={cardButton}>Подробнее</Button>
                </MediaCardContent>
              </MediaCard>
            </CardLinkWithGAPromoClick>
          )
        )}
      </div>
    </section>
  );
};
